module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1n4n8r-6a1ce77b5b4c6748b4189e689def7454.svg";